import React, { Component } from "react";
import Image from 'react-image-webp';

import dots from '../assets/images/dots.svg';
import soft from '../assets/images/soft.png';
import webp from '../assets/images/webp/soft.webp';

class Soft extends Component {

    render() {
        return (
            <section id="facts" className="video-counter pt-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="video-content mt-50 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.5s">
                                <img className="dots" src={dots} alt="dots" />
                                <div className="video-wrapper">
                                    <div className="video-image">
                                        <Image alt="Soft" src={soft} webp={webp} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="counter-wrapper mt-50 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.8s">
                                <div className="counter-content">
                                    <div className="section-title">
                                        <div className="line"></div>
                                        <h3 className="title">Revenda autorizada <span> Soft</span></h3>
                                    </div>
                                </div>
                                <div className="row no-gutters">
                                    <div className="col-4">
                                        <div className="single-counter counter-color-1 d-flex align-items-center justify-content-center">
                                            <div className="counter-items text-center">
                                                <span className="count"><span className="counter">Vários</span></span>
                                                <p className="text">Modelos</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="single-counter counter-color-2 d-flex align-items-center justify-content-center">
                                            <div className="counter-items text-center">
                                                <span className="count"><span className="counter">Diversas</span></span>
                                                <p className="text">Cores</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="single-counter counter-color-3 d-flex align-items-center justify-content-center">
                                            <div className="counter-items text-center">
                                                <span className="count"><span className="counter">Água</span></span>
                                                <p className="text">Pura</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Soft;
